// For /prescription-tracking status filter
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export const statusOptions = [
  { value: '', label: 'All' },
  { value: 'submitted', label: 'Submitted' },
  { value: 'approved', label: 'Approved' },
  { value: 'declined', label: 'Declined' },
  { value: 'sentToPharmacy', label: 'Sent To Pharmacy' },
  { value: 'received', label: 'Received' },
  { value: 'rejectedByPharmacy', label: 'Rejected By Pharmacy' },
]

// For /prescription-tracking country filter
export const countryOptions = [
  { value: '', label: 'All' },
  { value: 'United States', label: 'United States' },
  { value: 'Canada', label: 'Canada' },
]

export const updateStatusOptions = [
  { value: 'approved', label: 'Approved' },
  //   { value: 'declined', label: 'Declined' },
  { value: 'sentToPharmacy', label: 'Sent To Pharmacy' },
  { value: 'received', label: 'Received' },
]

export const ROLES = {
  ADMIN: 'Admin',
  COUNSELOR: 'Counselor',
  DOCTOR: 'Doctor',
}

export const EVENT_TYPE = {
  BOOKED: 'booked',
  QUEUED: 'queued',
  ASAP: 'asap',
  CHAT: 'chat',
}

export const APPOINTMENT_STATUS = {
  SCHEDULED: 'SCHEDULED',
  MISSED: 'MISSED',
  COMPLETED: 'COMPLETED',
  QUEUED: 'QUEUED',
  INPROGRESS: 'INPROGRESS',
  CANCELLED: 'CANCELLED',
}

export const getCurrentTimesInTimezones = (timezones) => {
  // Convert single timezone string to an array
  const timezoneArray = Array.isArray(timezones) ? timezones : [timezones]

  return timezoneArray.reduce((acc, tz) => {
    acc[tz] = dayjs().tz(tz).format('hh:mm A')
    return acc
  }, {})
}

export const getOrdinalSuffix = (i) => {
  const j = i % 10,
    k = i % 100
  if (j === 1 && k !== 11) {
    return i + 'st'
  }
  if (j === 2 && k !== 12) {
    return i + 'nd'
  }
  if (j === 3 && k !== 13) {
    return i + 'rd'
  }
  return i + 'th'
}

 // Utility function to convert short day names to full names
 export const convertDayToFullName = (shortDay) => {
  const daysMap = {
    Sun: 'Sunday',
    Mon: 'Monday',
    Tue: 'Tuesday',
    Wed: 'Wednesday',
    Thu: 'Thursday',
    Fri: 'Friday',
    Sat: 'Saturday',
  }
  return daysMap[shortDay] || shortDay // Return full name or the same string if not found
}

export const DATE_FORMAT = 'YYYY-MM-DD'
export const LAB_TRACKING_STATUS = {
  PENDING: 'pending',
  UNDETERMINED: 'undetermined',
  ABNORMAL: 'abnormal',
  NORMAL: 'normal',
  CRITICAL: 'critical',
}
export const labResultsStatusOptions = [
  { label: 'Critical', value: LAB_TRACKING_STATUS.CRITICAL },
  { label: 'Normal', value: LAB_TRACKING_STATUS.NORMAL },
  { label: 'Abnormal', value: LAB_TRACKING_STATUS.ABNORMAL },
];

export const labStatusFilterOptions = [
  { label: 'Pending', value: LAB_TRACKING_STATUS.PENDING },
  { label: 'Awaiting', value: 'awaiting' },
  { label: 'Undetermined', value: LAB_TRACKING_STATUS.UNDETERMINED },
  { label: 'Abnormal', value: LAB_TRACKING_STATUS.ABNORMAL },
  { label: 'Normal', value: LAB_TRACKING_STATUS.NORMAL },
  { label: 'Critical', value: LAB_TRACKING_STATUS.CRITICAL },
];

export const labTypeFilterOptions = [
  { label: 'Lab', value: 'Lab' },
  { label: 'Imaging', value: 'Imaging' },
];

export const activityStatusOptions = [
  { label: 'Open', value: 'open' },
  { label: 'Closed', value: 'closed' },
  { label: 'Awaiting Reports', value: 'awaiting' },
];
